import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { I18nProvider } from "@/context/I18nContext";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Stations from "@/pages/Stations";
import StationDetail from "@/pages/StationDetail";
import MapView from "@/pages/MapView";
import Alerts from "@/pages/Alerts";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import Analytics from "@/pages/Analytics";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import ProductsCatalog from "@/pages/ProductsCatalog";
import AdminProducts from "@/pages/AdminProducts";
import VerifyEmail from "@/pages/VerifyEmail";
import About from "@/pages/About";
import PublicProduct from "@/pages/PublicProduct";
import { VisitTracker } from "@/components/VisitTracker";
import { CookieConsent } from "@/components/CookieConsent";

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false} disableTransitionOnChange>
      <I18nProvider>
      <AuthProvider>
      <BrowserRouter>
        <VisitTracker />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/sobre" element={<About />} />
          <Route path="/p/:id" element={<PublicProduct />} />
          <Route path="/productos" element={<ProtectedRoute><ProductsCatalog /></ProtectedRoute>} />
          <Route path="/admin/productos" element={<ProtectedRoute adminOnly><AdminProducts /></ProtectedRoute>} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/stations" element={<ProtectedRoute><Stations /></ProtectedRoute>} />
          <Route path="/stations/:id" element={<ProtectedRoute><StationDetail /></ProtectedRoute>} />
          <Route path="/map" element={<ProtectedRoute><MapView /></ProtectedRoute>} />
          <Route path="/alerts" element={<ProtectedRoute><Alerts /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute managerOnly><Users /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute adminOnly><Settings /></ProtectedRoute>} />
          <Route path="/analytics" element={<ProtectedRoute adminOnly><Analytics /></ProtectedRoute>} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
    </I18nProvider>
    </ThemeProvider>
  );
}

export default App;
